<template>
  <span>&nbsp;</span>
</template>

<style scoped>
span {
    margin-right: 1em;
}
</style>

<script>
/* eslint-disable semi */
import { Component } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

@Component
export default class AppSeparator extends AppComponent {}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppSeparator.vue